module.exports = __webpack_public_path__ + "media/images/countryrect/hm-a047e279776358545bd7e9b03704a2f7.svg";